import { useSnackbar } from '@brands/hooks/useStackbar';
import { listAllLanguages } from '@brands/services/identity/listAllLanguages';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import { OptionLanguage } from '@brands/Utils/selectOptions';
import React, { FC, useEffect, useState } from 'react';
import Modal, { Styles } from 'react-modal';

import { GroupSummary } from '../../../../services/patient_plan/types/types';
import EditDependent from '../../../MyProfile/Patient/Sections/Dependent/EditDependent';
import styles from './styles.module.scss';

interface CustomStylesDashboard {
  overlay: Styles['overlay'];
  content: Styles['content'];
}

interface AddDependentModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isFromSelectNeeds?: boolean;
  patientPlanId?: number | undefined;
  onGroupUpdated?: (next: GroupSummary) => void;
}

const userRoleCustomStylesDashboard: CustomStylesDashboard = {
  ...customStylesDashboard,
  overlay: {
    ...customStylesDashboard.overlay,
    backgroundColor: '#1f2b38f0',
    overflowY: 'hidden',
  },
  content: {
    ...customStylesDashboard.content,
    width: '100%',
    maxWidth: '90vw',
    height: '90%',
    maxHeight: '90vh',
    backgroundColor: '#F0F0F0',
    borderRadius: '11px',
    opacity: '1',
    padding: '0',
    alignItems: 'flex-start',
  },
};

const AddDependentModal: FC<AddDependentModalProps> = ({
  isOpen,
  setIsOpen,
  isFromSelectNeeds = false,
  patientPlanId = undefined,
  onGroupUpdated = () => {},
}) => {
  const { showSnackbar } = useSnackbar();

  const [languageOptions, setLanguageOptions] = useState<OptionLanguage[]>([]);
  const [validationResponseId, setValidationResponseId] = useState('');

  const fetchLanguageOptions = async (): Promise<void> => {
    const data = await listAllLanguages();
    const transformedData = data.map((language) => ({
      value: language.locale,
      label: language.name,
      id: language.id,
    }));
    setLanguageOptions(transformedData);
  };

  const closeModal = (): void => {
    setIsOpen(false);
  };

  useEffect(() => {
    fetchLanguageOptions();
  }, []);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={userRoleCustomStylesDashboard}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.profileContainer}>
        <div className={styles.contentContainer} style={{ padding: '40px 80px' }}>
          <div>
            <EditDependent
              setIsEditDependent={setIsOpen}
              dependentId={0}
              languageOptions={languageOptions}
              isModal
              validationResponseId={validationResponseId}
              setValidationResponseId={setValidationResponseId}
              isFromSelectNeeds={isFromSelectNeeds}
              showDeleteDependentConfirmationModal={false}
              setShowDeleteDependentConfirmationModal={() => {}}
              showSnackbar={showSnackbar}
              isFromPatientIntake={false}
              patientPlanId={patientPlanId}
              onGroupUpdated={onGroupUpdated}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default AddDependentModal;
